export default __webpack_public_path__ + "static/media/logout.664d58de.svg";